import { Component, Input } from '@angular/core';
import { Models } from '@ibexfusion/models'
import moment from 'moment';
import * as _ from 'lodash';
import { ActiveStateService } from '@services/active-state/active-state.service';

@Component({
    selector: 'dynamic-content-table-active-state',
    templateUrl: './dynamic-content-table-active-state.component.html',
    styleUrls: ['./dynamic-content-table-active-state.component.scss'],
    standalone: false
})
export class DynamicContentTableActiveStateComponent {
  @Input() item: any;
  @Input() app: Models.PackageInstalledApp;

  public checkActiveState(element, now = new Date()) {
    return new ActiveStateService(this.app).check(element, now);
  }
}
